import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
interface ProductCardProps {
  title: string;
  price: string;
  oldPrice?: string;
  description: string;
  image: string;
  features?: string[];
  recommended?: boolean;
  delay?: number;
  buyLink?: string;
}
export function ProductCard({
  title,
  price,
  oldPrice,
  description,
  image,
  features = [],
  recommended = false,
  delay = 0,
  buyLink = 'Link de tu checkout'
}: ProductCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} whileHover={{
    y: -8
  }} className={`relative flex flex-col overflow-hidden rounded-2xl border bg-white shadow-xl transition-shadow duration-300 hover:shadow-2xl ${recommended ? 'border-[#FF6B35] ring-2 ring-[#FF6B35] ring-offset-2' : 'border-gray-200'}`} data-id="element-116">
      {recommended && <div className="absolute top-0 right-0 z-10 rounded-bl-xl bg-[#FF6B35] px-4 py-1 text-sm font-bold text-white" data-id="element-117">
          Más Vendido
        </div>}

      <div className="aspect-square w-full overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100" data-id="element-118">
        <img src={image} alt={title} className="h-full w-full object-cover transition-transform duration-500 hover:scale-110" data-id="element-119" />
      </div>

      <div className="flex flex-1 flex-col p-6" data-id="element-120">
        <h3 className="mb-2 text-2xl font-bold text-gray-900" data-id="element-121">{title}</h3>
        <p className="mb-4 text-sm text-gray-500" data-id="element-122">{description}</p>

        <div className="mb-6 flex items-baseline gap-3" data-id="element-123">
          <span className="text-3xl font-bold text-[#FF6B35]" data-id="element-124">{price}</span>
          {oldPrice && <span className="text-lg text-gray-400 line-through" data-id="element-125">
              {oldPrice}
            </span>}
          <span className="ml-auto text-sm text-gray-500" data-id="element-126">ARS</span>
        </div>

        {features.length > 0 && <ul className="mb-8 space-y-3 flex-1" data-id="element-127">
            {features.map((feature, idx) => <li key={idx} className="flex items-start text-sm text-gray-600" data-id="element-128">
                <Check className="mr-2 h-5 w-5 shrink-0 text-[#FF6B35]" data-id="element-129" />
                {feature}
              </li>)}
          </ul>}

        <CTAButton href={buyLink} fullWidth variant={recommended ? 'primary' : 'outline'} data-id="element-130">
          Comprar ahora
        </CTAButton>
      </div>
    </motion.div>;
}